import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "./Context/UserProvider";
import { CircularProgress } from "@mui/material";
import LoadingMainPage from "./Common/Loading/LoadingMainPage";

function ProtectedRoute({ children }) {
  const { isLoggedIn, isLoading } = useUser();
  const location = useLocation();
  // console.log("ProtectedRoute render:", { isLoggedIn, isLoading });

  if (isLoading) {
    return <LoadingMainPage isLoading={true} />; //  bloquea el render mientras carga
  }

  if (!isLoggedIn) {
    // console.log("Protected Route isLoggedIn", isLoggedIn);

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si hay children (ej: Layout), renderízar
  if (children) return children;

  // Si no hay children, renderiza Outlet para que se muestren las rutas hijas
  return <Outlet />;
}

export default ProtectedRoute;
